import { PrivacyPolicyBody } from "@/components/legal/PrivacyPolicyBody";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { Section } from "@/components/ui";
import { PRIVACY_LAST_UPDATED, PRIVACY_SEO } from "@/data/privacyPolicy";
import { Seo } from "@/lib/seo/Seo";
import { breadcrumbSchema } from "@/lib/seo/schema";

export default function Privacy() {
  return (
    <SiteLayout>
      <Seo
        title={PRIVACY_SEO.title}
        description={PRIVACY_SEO.description}
        path={PRIVACY_SEO.path}
        jsonLd={[
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Privacy Policy", path: PRIVACY_SEO.path },
          ]),
        ]}
      />
      <div data-testid="privacy-page" className="page-main bg-white">
        <Section className="py-10 sm:py-14">
          <div className="mx-auto max-w-3xl px-4 sm:px-6">
            <p className="text-sm font-semibold uppercase tracking-wide text-brand-600">Legal</p>
            <h1 className="mt-2 text-3xl font-bold text-ink sm:text-4xl">Privacy Policy</h1>
            <p className="mt-3 text-sm font-semibold text-ink/70">Last updated: {PRIVACY_LAST_UPDATED}</p>
            <PrivacyPolicyBody />
          </div>
        </Section>
      </div>
    </SiteLayout>
  );
}
